import { http_api } from "../../leadg-api";
const getLeaderboard = (startDate, endDate) => http_api.get(`additional-leaderboard?startDate=${startDate}&endDate=${endDate}`);
const getAgents = () => http_api.get("additional-leaderboard/agents");
const getEntries = (year) => http_api.get(`additional-leaderboard/entries?year=${year}`);
const createEntry = (entry) => http_api.post("additional-leaderboard/entries", entry);
const updateEntry = (id, entry) => http_api.put(`additional-leaderboard/entries/${id}`, entry);
const deleteEntry = (id) => http_api.delete(`additional-leaderboard/entries/${id}`);
const AdditionalLeaderboardApi = {
    getLeaderboard,
    getAgents,
    getEntries,
    createEntry,
    updateEntry,
    deleteEntry,
};
export default AdditionalLeaderboardApi;
